import { AxiosRequestConfig } from 'axios'

import { ApiRequest, ApiRequests } from '../types/api'

export const API_REQUEST = 'API_REQUEST'
export const API_REQUESTS = 'API_REQUESTS'

export const apiRequest = ({
  url,
  method = 'get',
  entity = '',
  originalPayload = {},
  onSuccess,
  onError,
  ...options
}: ApiRequest & AxiosRequestConfig) => {
  return {
    type: `[command] ${entity}/${API_REQUEST}`,
    payload: { url, method, ...options },
    meta: { onSuccess, onError, entity, originalPayload },
  }
}

export const apiRequests = ({
  urls,
  method = 'get',
  entity = '',
  originalPayload = {},
  onSuccess,
  onError,
  ...options
}: ApiRequests & AxiosRequestConfig) => {
  return {
    type: `[command] ${entity}/${API_REQUESTS}`,
    payload: { urls, method, ...options },
    meta: { onSuccess, onError, entity, originalPayload },
  }
}
